module.exports = __webpack_public_path__ + "img/Empty-state.dd805b50.svg";